import { UserChangePasswordFormDTO } from 'interfaces/users/users'

export const getUserChangePasswordFormValues = (): UserChangePasswordFormDTO => ({
  currentPassword: '',
  password: '',
  confirmPassword: '',
})
